import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import initializeForm from './initializeForm';
import setIsNewRecord from './setIsNewRecord';
import toggleModalProduct from './toggleModalProduct';

const mapItems = (items) => {
    if (isEmpty(items)) return [{ item: '' }];

    return items.map((item) => ({
        item: item.id,
    }));
};

export default (item) => (dispatch) => {
    if (item) {
        const newValues = {
            country: item?.country?.id,
            id: item.id,
            name: item.name,
            products: mapItems(item.products),
            template_bom: get(item, ['template_bom', 'id'], ''),
            template_system: get(item, ['template_system', 'id'], ''),
            type_application: item.type_application,
        };
        dispatch(initializeForm(newValues));
    }
    dispatch(setIsNewRecord(false));
    dispatch(toggleModalProduct(true));
};
